import { withNodeResizable } from '../shared/NodeResizable';
import { Portal } from '../shared/Portal';
import { createEmbedExtension } from '../shared/createEmbedExtension';
import { EmbedRendererProps } from '../shared/types';

const URL_REGEX = new RegExp(
  '^https://([A-Za-z0-9](?:[A-Za-z0-9-]{0,61}[A-Za-z0-9])?).typeform.com/to/(.*)$',
);
export const ENABLED = [URL_REGEX];

export const Component = ({ url, ...rest }: EmbedRendererProps<any>) => (
  <Portal {...rest} url={url} title="Typeform Embed" fullHeight withMetadata />
);

export default createEmbedExtension({
  regexp: [URL_REGEX],
  name: 'typeform-embed',
  component: withNodeResizable(Component, {
    lockAspectRatio: true,
    defaultHeight: 500,
  }),
  addCommandOption: {
    title: 'Typeform',
    description: 'Embed a Typeform.',
    searchTerms: ['embed', 'typeform'],
    icon: 'logos:typeform',
  },
});
